import { Component, OnInit } from '@angular/core';
import { NotificationService } from '../../../../shared/components/notifications/notification.service';
import { PageEvent } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { DeleteConfirmDialogComponent } from '../../../../shared/components/delete-confirm-dialog/delete-confirm-dialog.component';
import { TransactionService } from '../../../../core/services/transaction.service';
import { TransactionForListing } from '../../../../core/models/transactions/transaction-for-listing.model';
import { TransactionsRequestFilter } from '../../../../core/models/transactions/transaction-request-filter.model';

@Component({
  selector: 'app-transaction-list',
  standalone: false,
  templateUrl: './transaction-list.component.html',
  styleUrl: './transaction-list.component.css'
})



export class TransactionListComponent implements OnInit {
  transactions: TransactionForListing[] = [];
  isLoading = false;

  currentPage = 0;
  pageSize = 10;
  totalItems = 0;

  searchTerm: string | undefined = undefined;

  constructor(
    private transactionService: TransactionService,
    private notificationService: NotificationService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    const savedSearch = sessionStorage.getItem('transactions.list.search');
    const savedPage = sessionStorage.getItem('transactions.list.page');
    const savedPageSize = sessionStorage.getItem('transactions.list.pageSize');

    this.searchTerm = savedSearch !== null ? (savedSearch || undefined) : this.searchTerm;
    this.currentPage = savedPage !== null ? parseInt(savedPage, 10) || 0 : this.currentPage;
    this.pageSize = savedPageSize !== null ? parseInt(savedPageSize, 10) || this.pageSize : this.pageSize;

    this.loadTransactions();
  }

  loadTransactions(): void {
    this.isLoading = true;
    const apiPage = this.currentPage + 1;

    const filter: TransactionsRequestFilter = {
      page: apiPage,
      pageSize: this.pageSize,
      ...(this.searchTerm !== undefined && { search: this.searchTerm })
    };

    this.transactionService.getPaginatedTransactions(filter).subscribe({
      next: ({ data, pagination }) => {
        this.transactions = data;
        this.totalItems = pagination.totalItems;
        this.pageSize = pagination.itemsPerPage;
        this.currentPage = pagination.currentPage - 1;
        this.isLoading = false;
      },
      error: () => {
        this.notificationService.showError('Failed to load transactions');
        this.isLoading = false;
      }
    });
  }

  onSearchChange(): void {
    this.currentPage = 0;
    sessionStorage.setItem('transactions.list.search', this.searchTerm || '');
    sessionStorage.setItem('transactions.list.page', this.currentPage.toString());
    sessionStorage.setItem('transactions.list.pageSize', this.pageSize.toString());
    this.loadTransactions();
  }

  clearSearch(): void {
    this.searchTerm = undefined;
    this.currentPage = 0;
    sessionStorage.removeItem('transactions.list.search');
    sessionStorage.setItem('transactions.list.page', this.currentPage.toString());
    sessionStorage.setItem('transactions.list.pageSize', this.pageSize.toString());
    this.loadTransactions();
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    sessionStorage.setItem('transactions.list.page', this.currentPage.toString());
    sessionStorage.setItem('transactions.list.pageSize', this.pageSize.toString());
    this.loadTransactions();
  }

  deleteTransaction(id: number): void {
    const dialogRef = this.dialog.open(DeleteConfirmDialogComponent, {
      width: '400px',
      data: { itemName: 'this transaction' }
    });

    dialogRef.afterClosed().subscribe(confirmed => {
      if (confirmed) {
        this.transactionService.softDeleteTransaction(id).subscribe({
          next: () => {
            this.notificationService.showSuccess('Transaction deleted successfully');
            this.loadTransactions();
          },
          error: () => this.notificationService.showError('Failed to delete transaction')
        });
      }
    });
  }
}

